"use strict";
"use client";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
exports.__esModule = true;
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _BadgeListItem = require("../../BadgeList/BadgeListItem");
var _Stack = _interopRequireDefault(require("../../Stack"));
var _ItineraryText = _interopRequireDefault(require("../ItineraryText"));
const ItineraryBadgeListItem = ({
  children,
  cancelledValue,
  withBackground,
  dataTest,
  type = "neutral",
  icon,
  strikeThrough
}) => {
  return /*#__PURE__*/React.createElement(_BadgeListItem.ItemWrapper, {
    dataTest: dataTest
  }, /*#__PURE__*/React.createElement(_BadgeListItem.VerticalBadge, {
    type: type,
    icon: icon
  }), /*#__PURE__*/React.createElement(_BadgeListItem.BadgeContent, {
    style: {
      marginTop: cancelledValue ? `4px` : ""
    }
  }, /*#__PURE__*/React.createElement(_Stack.default, {
    direction: "column",
    spacing: "100"
  }, /*#__PURE__*/React.createElement(_ItineraryText.default, {
    withBackground: withBackground,
    type: withBackground && type !== "neutral" ? type : "secondary",
    weight: withBackground ? "medium" : "normal",
    size: "small",
    as: "span",
    strikeThrough: strikeThrough
  }, children), cancelledValue && /*#__PURE__*/React.createElement(_ItineraryText.default, {
    type: "secondary",
    size: "small",
    as: "span",
    strikeThrough: true,
    weight: "medium"
  }, cancelledValue))));
};
var _default = exports.default = ItineraryBadgeListItem;